import React from 'react'
import '../styles/Servicios/ClientsServices.css'
import { useTranslation } from 'react-i18next'

function ClientsServices() {
  const {t} = useTranslation();

  return (
    <section>
      <h3 className='clients'>{t("clients")}</h3>
      <br />
      <div className='subtitle-pad'>
          <h3>{t("client_1")}</h3>
      </div>
      <div className='client-text'>
        <div className='client-first-services'>
          <h4>{t("client_2")}</h4>
          <p>{t("client_3")}</p>
          
          <h4>{t("client_4")}</h4>
          <p>{t("client_5")}</p>
        </div>
      </div>
    </section>
  )
}

export default ClientsServices